/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Vehicle_InvolvementInputs */

const en_case_field_vehicle_involvement = /** @type {(inputs: Case_Field_Vehicle_InvolvementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vehicle involvement type`)
};

const pt_br2_case_field_vehicle_involvement = /** @type {(inputs: Case_Field_Vehicle_InvolvementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de envolvimento do veículo`)
};

/**
* | output |
* | --- |
* | "Vehicle involvement type" |
*
* @param {Case_Field_Vehicle_InvolvementInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_vehicle_involvement = /** @type {((inputs?: Case_Field_Vehicle_InvolvementInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Vehicle_InvolvementInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_vehicle_involvement(inputs)
	return pt_br2_case_field_vehicle_involvement(inputs)
});